import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector   : 'fuse-nav-vertical-group',
    templateUrl: './nav-vertical-group.component.html',
    styleUrls  : ['./nav-vertical-group.component.scss']
})
export class FuseNavVerticalGroupComponent
{
    @HostBinding('class') classes = 'nav-group nav-item';
    @Input() item: any;

    constructor()
    {
    }

}



// WEBPACK FOOTER //
// ./src/@fuse/components/navigation/vertical/nav-group/nav-vertical-group.component.ts